<template>
  <v-container class="mt-5">
    <v-card class="elevation-24" style="border-radius: 8px">
      <v-card-text>
        <v-row justify="space-around">
          <v-card
            color="indigo lighten-2"
            class="elevation-20"
            style="margin-top: -40px; border-radius: 8px"
            width="100"
            height="80"
          >
            <v-card-text>
              <v-row justify="center" align='center'>
                <span class="display-1 black--text">{{ stat.value }}</span>
              </v-row>
            </v-card-text>
          </v-card>
          <span class="headline black--text">{{ title }}</span>
        </v-row>
      </v-card-text>
      <v-card-text></v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    stat: {
      type: Object,
      required: true
    }
  },
  computed: {
    title(){
      if (this.stat.key == "totalUser") {
        return "Total Users"
      }else if (this.stat.key == 'totalIdea') {
        return "Total Ideas"
      }
    }
  }
};
</script>